export const materialOptions: { label: string; value: MaterialKind }[] = [
  {
    label: 'Nadelholz',
    value: 'Softwood',
  },
  {
    label: 'Brettschichtholz',
    value: 'Glulam',
  },
  {
    label: 'Furnierschichtholz',
    value: 'LVL',
  },
  {
    label: 'Stahl',
    value: 'Steel',
  },
]
